import Vue from 'vue';
import Router, { RouteConfig } from 'vue-router';

Vue.use(Router);

export const home: RouteConfig = {
  path: 'home',
  name: 'home',
  component: () => import(/* webpackChunkName: "home" */ '@/views/Home/Home.vue'),
  meta: {
    routerName: 'home',
    noChild: false,
    iconName: 'home',
    rootPage: true
  },
  children: [
    {
      path: 'studentDetail',
      name: 'studentDetail',
      component: () => import(/* webpackChunkName: "home" */ '@/views/StudentDetail/StudentDetail.vue'),
      meta: {
        routerName: 'studentDetail',
        noChild: false,
      },
    },
  ],
};

export const applicationForm: RouteConfig = {
  path: 'application',
  name: 'application',
  component: () => import(/* webpackChunkName: "home" */ '@/views/ApplicationForm/ApplicationForm.vue'),
  meta: {
    routerName: 'application',
    noChild: false,
  },
};

export const message: RouteConfig = {
  path: 'message',
  name: 'message',
  component: () => import(/* webpackChunkName: "message" */ '@/views/Message/Message.vue'),
  meta: {
    routerName: 'message',
    rootPage: true,
    noChild: true,
    iconName: 'mail',
  },
  children: [
    {
      path: 'sent',
      name: 'sent',
      component: () => import(/* webpackChunkName: "message" */ '@/views/Message/Sent/Sent.vue'),
      meta: {
        routerName: 'sent',
        noChild: false,
      },
      children: [
        {
          path: 'notice',
          name: 'notice',
          component: () => import(/* webpackChunkName: "message" */ '@/views/Message/SendMessage/SendMessage.vue'),
          meta: {
            routerName: 'notice',
            noChild: true,
          },
        },
        {
          path: 'sentMsgDetail',
          name: 'sentMsgDetail',
          component: () => import(/* webpackChunkName: "message" */ '@/views/Message/Sent/MessageDetail.vue'),
          meta: {
            routerName: 'detail',
            noChild: true,
          },
        },
      ],
    },
    {
      path: 'inbox',
      name: 'inbox',
      component: () => import(/* webpackChunkName: "message" */ '@/views/Message/Inbox/Inbox.vue'),
      meta: {
        routerName: 'inbox',
        noChild: false,
      },
      children: [
        {
          path: 'receiveMsgDetail',
          name: 'receiveMsgDetail',
          component: () => import(/* webpackChunkName: "message" */ '@/views/Message/Inbox/MessageDetail.vue'),
          meta: {
            routerName: 'detail',
            noChild: true,
          },
        },
      ],
    },
  ],
};

export const userCenter: RouteConfig = {
  path: 'userCenter',
  name: 'userCenter',
  component: () => import(/* webpackChunkName: "userCenter" */ '@/views/UserCenter/UserCenter.vue'),
  meta: {
    routerName: 'userCenter',
    noChild: false,
    iconName: 'idcard',
  },
};

// export const uniform: RouteConfig = {
//   path: 'uniform',
//   name: 'uniform',
//   component: () => import(/* webpackChunkName: "uniform" */ '@/views/Uniform/Uniform.vue'),
//   meta: {
//     routerName: 'uniform',
//     noChild: false,
//   },
// };

// export const schoolIntroduction: RouteConfig = {
//   path: '/:id/introduction',
//   name: 'introduction',
//   component: () => import(/* webpackChunkName: "schoolIntroduction" */ '@/views/Introduction/Introduction.vue'),
//   meta: {
//     routerName: 'introduction',
//     noChild: false,
//     iconName: 'int',
//   },
// };
